<template>
  <div>
    <div
      @mouseenter="canvasEnableHighlight({ event: $event })"
      klickbox-edit-item="option"
      :klickbox-edit-label="$t('edit.canvas.answer_options')">
      <div
        class="kbx-form"
        v-for="option in stepPreview.options">
        <label
          :style="stepStyle('option')"
          :class="[stepPreview.multiple_answers ? 'kbx-checkbox' : 'kbx-radio']">
          <input
            :type="[stepPreview.multiple_answers ? 'checkbox' : 'radio']"
            name="example">
          <span>{{option.label}}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    stepStyle: 'stepStyle',
    stepPreview: 'stepPreview',
  }),
  methods: mapActions([
    'canvasEnableHighlight',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Options.vue?e43f754e
 **/